// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"Banner_thecomp__LokIm"};